import { useContext } from 'react'

import {
  Navigate,
  Route,
  Routes as RoutesRRD,
  useLocation,
} from 'react-router-dom'

import { Layout } from '../components/Layout/layout.comp'
import { AuthContext } from '../contexts/auth'
import { Cookies } from '../pages/Cookies'
import { Login } from '../pages/Login/login.page'
import { RecoveryPassword } from '../pages/RecoveryPassword'
import { RouteItem } from '../utilities/menu/routes'
import { getFilteredRoutes } from '../utilities/menu/user-has-permission'
import { redirectToUrl } from '../utilities/urls'

export function Routes() {
  const { user, userType, authLoading } = useContext(AuthContext)

  const userRoutes = userType && getFilteredRoutes(user)

  const location = useLocation()
  const path = location.pathname

  const params = new URLSearchParams(location.search)
  const redirect = params.get('redirect')

  return (
    <RoutesRRD>
      {/* <Route path="*" element={<Navigate to="/" />} /> */}
      <Route
        path="/login"
        element={
          user ? (
            <Navigate
              to={redirectToUrl(userRoutes || [], redirect || undefined)}
            />
          ) : (
            <Login />
          )
        }
      />
      <Route path="/password/recovery" element={<RecoveryPassword />} />
      <Route path="/cookies" element={<Cookies />} />

      {!user && !authLoading && (
        <Route
          path="/*"
          element={<Navigate to={`/login?redirect=${path}`} />}
        />
      )}

      <Route path="/" element={user ? <Layout /> : <Navigate to="/login" />}>
        {userRoutes &&
          user &&
          userRoutes.map((route: RouteItem, index: number) => (
            <Route key={index} path={route.url} element={route.element} />
          ))}
      </Route>
    </RoutesRRD>
  )
}
